import { useCallback } from 'react';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import LandingArrow from './LandingArrow';
import LandingDialog from './LandingDialog';

function LandingContactDialog({ open, onClose }) {
    const { getLangPath } = useLangContext();
    const close = useCallback(() => onClose(), [onClose]);

    return (
        <LandingDialog
            id="contact"
            open={open}
            onClose={close}
            className="dialog"
            labelledBy="dialog-title"
        >
            <h3 id="dialog-title">{getLangPath('landing.contact.title')}</h3>
            <p>{getLangPath('landing.contact.text')}</p>
            <div className="contact-options">
                <a href="mailto:affilers@jetvix.com">
                    <span>{getLangPath('landing.contact.email')}</span>
                    <strong>
                        affilers@jetvix.com
                        {' '}
                        <LandingArrow/>
                    </strong>
                </a>
                <a href="https://t.me/user117624" target="_blank" rel="noopener noreferrer">
                    <span>{getLangPath('landing.contact.telegram')}</span>
                    <strong>
                        J.Affilers
                        {' '}
                        <LandingArrow/>
                    </strong>
                </a>
            </div>
            <p className="contact-partner">{getLangPath('landing.contact.partner')}</p>
            <button className="btn" id="close-dialog" type="button" onClick={close}>
                {getLangPath('landing.contact.back')}
            </button>
        </LandingDialog>
    );
}

export default LandingContactDialog;
